/**
 * Persist STOQ preorder info onto the *line item* at add-to-cart time.
 *
 * We do this by populating a hidden `properties[_STOQ_preorder]` input on the
 * product form right before submission, based on the selected selling plan.
 *
 * This ensures the value is stored on the order line item and is available
 * in transactional emails without any cart/update requests.
 */
(function () {
  function parseJsonScript(scriptEl) {
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent || "null");
    } catch {
      return null;
    }
  }

  function getSelectedSellingPlanId(form) {
    // Shopify standard selling plan input
    const el = form.querySelector('[name="selling_plan"]');
    if (el && "value" in el && el.value) return String(el.value);
    return "";
  }

  function setStoqPreorderProperty(form) {
    const input = form.querySelector("input[data-stoq-preorder-property]");
    if (!input) return;

    const selectedPlanId = getSelectedSellingPlanId(form);
    if (!selectedPlanId) {
      input.value = "";
      input.disabled = true;
      return;
    }

    const map = parseJsonScript(
      form.querySelector("script[data-stoq-selling-plan-map]"),
    );
    const name = map?.by_id?.[selectedPlanId];
    const value = typeof name === "string" ? name : "";
    input.value = value;
    input.disabled = value.trim().length === 0;
  }

  function hookCheckoutSubmit(formSelector) {
    document.addEventListener(
      "submit",
      async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.matches(formSelector)) return;

        setStoqPreorderProperty(form);
      },
      true,
    );
  }

  hookCheckoutSubmit("form[data-product-form]");
})();
